import {Component, Inject, OnInit} from '@angular/core';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-pdf-viewer-dialog',
  templateUrl: './pdf-viewer-dialog.component.html',
  styleUrls: ['./pdf-viewer-dialog.component.scss']
})
export class PdfViewerDialogComponent implements OnInit {

  isError: boolean = false;
  documentLoaded: boolean = false;

  static getConfigBuilder(): PdfViewerDialogConfig {
    return new PdfViewerDialogConfig();
  }

  get errorIcon(): string {
    return './assets/images/icons/blad-transakcji.svg';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: PdfViewerDialogData,
              private dialog: MatDialogRef<PdfViewerDialogComponent>) { }

  ngOnInit() {

  }

  close() {
    this.dialog.close();
  }

  onError(error) {
    this.isError = true;
    this.documentLoaded = true;
  }

  onProgress(event) {

  }

  onAfterLoadComplete(event) {
    this.documentLoaded = true;
  }

}

export class PdfViewerDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'pdf-viewer-dialog-panel'
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}

export interface PdfViewerDialogData {
  pdfUrl: string;
}
